export const HOME = "/";
export const ABOUT = "/about-us";
export const PRODUCTS = "/products";
export const PRODUCT_DETAILS = "/products/:id";
export const CONTACT_US = "/contact-us";
export const TRAININGS = "/trainings";
export const REVIEWS = "/reviews";
export const FAQ = "/faq";
export const POLICIES = "/policies";
export const PRIVACY_POLICY = "/privacy-policy";
export const BLOGS = "/blogs";
export const ACCOUNT = "/account";
export const LOGIN = "/login";
export const REGISTER = "/register";
export const FORGOT_PASSWORD = "/forgot-password";
export const CART = "/cart";
export const CHECKOUT = "/checkout";
export const NOT_FOUND = "/*";
// "addresses"
